export const AUTH_SERVICE_PATH = '/auth'
export const SHIPMENT_SERVICE_PATH = '/shipment'
export const BILLING_SERVICE_PATH = '/billing'
export const COMMUNICATION_SERVICE_PATH = '/communication'
export const ANALYTICS_SERVICE_PATH = '/analytics'
export const AGENTS_SERVICE_PATH = '/agents'

export const ADMIN_API_PREFIX = '/admin/api/v1'

export const ADMIN_AUTH_LOGIN_PATH = `${AUTH_SERVICE_PATH}${ADMIN_API_PREFIX}/auth/login`
export const ADMIN_AUTH_REFRESH_PATH = `${AUTH_SERVICE_PATH}${ADMIN_API_PREFIX}/auth/refresh`
export const ADMIN_AUTH_LOGOUT_PATH = `${AUTH_SERVICE_PATH}${ADMIN_API_PREFIX}/auth/logout`
export const ADMIN_AUTH_ME_PATH = `${AUTH_SERVICE_PATH}${ADMIN_API_PREFIX}/auth/me`
export const ADMIN_AUTH_PASSKEY_OPTIONS_PATH = `${AUTH_SERVICE_PATH}${ADMIN_API_PREFIX}/auth/passkey/options`
export const ADMIN_AUTH_PASSKEY_PATH = `${AUTH_SERVICE_PATH}${ADMIN_API_PREFIX}/auth/passkey`
export const ADMIN_PASSKEYS_PATH = `${AUTH_SERVICE_PATH}${ADMIN_API_PREFIX}/auth/passkeys`
export const ADMIN_AUTH_RECOVERY_PATH = `${AUTH_SERVICE_PATH}${ADMIN_API_PREFIX}/auth/recovery`
export const ADMIN_AUTH_PASSKEY_SETUP_PATH = `${AUTH_SERVICE_PATH}${ADMIN_API_PREFIX}/auth/passkey/setup`
export const ADMIN_SUPERUSERS_PATH = `${AUTH_SERVICE_PATH}${ADMIN_API_PREFIX}/superusers`
